import { useEffect, useState } from 'react';
import checkIsUploadStable from '@anm/store/modules/uploads/helpers/checkIsStable';
import NotStableWarningModal from '@anm/components/NotStableWarningModal';
import { useSelector } from 'react-redux';
import { videoFolderSelectors } from '../../../../store/modules/videoFolder';

type HookProps = {
  projectId: string;
  initialCheck?: boolean;
  onSuccess?: () => void;
};

type CheckedProps = {
  cb?: () => void;
  showWarning?: boolean;
};

const useNotStableWarning = ({ projectId, initialCheck, onSuccess }: HookProps) => {
  const [isNotStable, setIsNotStable] = useState<boolean>();
  const [isWarning, setIsWarning] = useState<boolean>();

  const project = useSelector(state => videoFolderSelectors.selectProjectById(state, projectId));
  const isRendered = !!project?.extra.hostingId;

  const checkUpload = async ({ cb, showWarning = true }: CheckedProps) => {
    if (!isRendered) return cb?.();

    try {
      const isUploadStable = await checkIsUploadStable({ projectId });
      if (!isUploadStable) {
        setIsWarning(showWarning);
        setIsNotStable(true);
      } else {
        cb?.();
        showWarning && onSuccess?.();
      }
    } catch (e) {
      console.error(`Check upload error:`, e);
      setIsWarning(showWarning);
      setIsNotStable(true);
    }
  };

  useEffect(() => {
    initialCheck && checkUpload({});
  }, [initialCheck]);

  const renderWarningModal = () =>
    isNotStable && isWarning ? (
      <NotStableWarningModal onProceed={onSuccess} onClose={() => setIsNotStable(false)} />
    ) : null;

  return { isNotStable, checkUpload, renderWarningModal };
};

export default useNotStableWarning;
